import { useContext } from "react";
import { RefetchScope, RetailOrderContext } from "../context/RetailOrderContext";
import { CommunicationButton } from "../../../common/communication";

export default function RetailOrderCommunicationButton() {

	const { order, refetchOrder } = useContext(RetailOrderContext);

	let emailSubject = `${order.details.roNumber} - ${order.details.customerName.trim()}`;
	if (!!order.details.projectNumber) {
		emailSubject += ` - Project # ${order.details.projectNumber}`;
	}

	return (
		<CommunicationButton
			retailOrderID={order.details.retailOrderID}
			emailSubject={emailSubject}
			onMessageCreated={() => refetchOrder(RefetchScope.Notes)}
		/>
	)
}
